import { Box, Card, CardContent, Typography } from '@mui/material';

export const Links = () => {
    const links = [
        { text: 'New Jersey Ski & Snowboard Council', url: 'https://www.njssc.org/' },
        { text: 'MSC Member Google Drive (Newsletters, Minutes, Documents)', url: 'https://drive.google.com/drive/folders/1kj3NHMRUw8UKhCl5KRnPMxWf6cy0mL5-?usp=sharing'},
    ];
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '20px',
            }}
        >
            <Typography variant="h4" color="text.primary" gutterBottom>
                Links
            </Typography>

            <Card sx={{ width: '100%', margin: '20px' }}>
                <CardContent>
                {links.map((link, index) => (
                    <Typography variant="h6" color="text.secondary" gutterBottom>
                        <a href={`${link.url}`} target='_blank'>{link.text}</a>
                    </Typography>
                ))}
                </CardContent>
            </Card>
        </Box>
    );
};